module.exports = __webpack_public_path__ + "img/logoImg.a62f1721.png";